"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookMarkedProducts = void 0;
require("../../css/bookmarked-products-page.scss");
var GenericFunctions = require("../generic-functions");
var constants_1 = require("../constants/constants");
var queryString = require('query-string');
var api_constants_1 = require("../constants/api-constants");
var IframeComms = require("../frame-comms/iframe-comms");
var BookMarkedProducts = /** @class */ (function () {
    function BookMarkedProducts() {
    }
    BookMarkedProducts.init = function (memberNr) {
        //show the view
        $("#bookmarked-products-page").show();
        //Navigation buttons
        if (History.storedStates.length > 2) {
            $("#bookmarked-products-page .navigation-icons .back-button").off("click");
            $("#bookmarked-products-page .navigation-icons .back-button").on("click", function (e) {
                History.back();
            });
            $("#bookmarked-products-page .navigation").show();
        }
        else {
            $("#bookmarked-products-page .navigation").hide();
        }
        BookMarkedProducts.markedProducts = BookMarkedProducts.loadMarkedProductsFromStorage(memberNr);
        if (BookMarkedProducts.isLoadNeeded()) {
            BookMarkedProducts.loadData(memberNr);
        }
    };
    BookMarkedProducts.initData = function () {
        $(".remove-marked-product").off("click");
        $(".remove-marked-product").on("click", function () {
            var $product = $(this).parent();
            var id = $product.attr("id");
            $product.parent().remove();
            BookMarkedProducts.removeMarkedProduct(id);
        });
        $("#delete-product-modal-button").off("click");
        $("#delete-product-modal-button").on("click", function () {
            var id = $(this).attr("product-id");
            $("#" + id).parent().remove();
        });
        //set status
        BookMarkedProducts.setStatus();
    };
    BookMarkedProducts.removeMarkedProduct = function (id) {
        var numProducts = parseInt($("#total-bookmarked-products .value").text());
        if (!isNaN(numProducts)) {
            numProducts--;
            $("#total-bookmarked-products .value").text(numProducts);
        }
        BookMarkedProducts.removeMarkedProductFromLocalStorage(id, BookMarkedProducts.markedProducts);
        BookMarkedProducts.setStatus();
    };
    BookMarkedProducts.loadData = function (memberNr) {
        $("#products-marked-list").html("");
        if (BookMarkedProducts.markedProducts.length == 0) {
            return;
        }
        GenericFunctions.addLoadingIcon("#products-marked-container");
        var qs = "?" + queryString.stringify({ productIds: BookMarkedProducts.markedProducts });
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.BookMarkedProducts + qs,
        });
        promise.done(function (data) {
            var callBack = function () {
                $("#products-marked-list").html(data);
                BookMarkedProducts.initData();
                //update the marked products. Maybe some products are deleted
                BookMarkedProducts.markedProducts = $("#bookmarked-products-page .product-item").map(function () { return $(this).attr("id"); }).toArray();
                BookMarkedProducts.UpdateMarkedProductsInLocalStorage(memberNr);
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            GenericFunctions.showErrorMessage(constants_1.Constants.ErrorGettingMarkedProducts);
        });
        promise.always(function () {
            GenericFunctions.removeLoadingIcon("#products-marked-container");
            IframeComms.propagateHeight(false);
        });
    };
    BookMarkedProducts.loadMarkedProductsFromStorage = function (memberNr) {
        if (GenericFunctions.storageAvailable('localStorage')) {
            BookMarkedProducts.storageId = constants_1.Constants.CookiePrefixBookmarkedProducts + "-" + memberNr;
            //marked products
            if (!localStorage.getItem(BookMarkedProducts.storageId)) {
                return [];
            }
            else {
                return JSON.parse(localStorage.getItem(BookMarkedProducts.storageId));
            }
        }
    };
    BookMarkedProducts.loadAndGetMarkedProductsFromStorage = function (memberNr) {
        var markedProducts = BookMarkedProducts.loadMarkedProductsFromStorage(memberNr);
        return markedProducts;
    };
    BookMarkedProducts.removeMarkedProductFromLocalStorage = function (productId, markedProducts) {
        var index = markedProducts.indexOf(productId);
        if (index != -1) {
            markedProducts.splice(index, 1);
            if (!GenericFunctions.storageAvailable('localStorage')) {
                return;
            }
            ;
            localStorage.setItem(BookMarkedProducts.storageId, JSON.stringify(markedProducts));
        }
    };
    BookMarkedProducts.loadAndRemoveMarkedProductFromLocalStorage = function (memberNr, productId) {
        var markedProducts = BookMarkedProducts.loadMarkedProductsFromStorage(memberNr);
        this.removeMarkedProductFromLocalStorage(productId, markedProducts);
    };
    BookMarkedProducts.addMarkedProductToLocalStorage = function (memberNr, productId) {
        productId = productId.toString();
        var markedProducts = BookMarkedProducts.loadMarkedProductsFromStorage(memberNr);
        if (markedProducts.indexOf(productId) == -1) {
            markedProducts.push(productId);
            if (!GenericFunctions.storageAvailable('localStorage')) {
                return;
            }
            ;
            localStorage.setItem(BookMarkedProducts.storageId, JSON.stringify(markedProducts));
        }
    };
    BookMarkedProducts.UpdateMarkedProductsInLocalStorage = function (memberNr) {
        if (!GenericFunctions.storageAvailable('localStorage')) {
            return;
        }
        ;
        localStorage.setItem(BookMarkedProducts.storageId, JSON.stringify(BookMarkedProducts.markedProducts));
    };
    BookMarkedProducts.isMarkedProduct = function (memberNr, productId) {
        var markedProducts = BookMarkedProducts.loadMarkedProductsFromStorage(memberNr);
        return markedProducts.indexOf(productId) != -1;
    };
    BookMarkedProducts.isLoadNeeded = function () {
        return BookMarkedProducts.markedProducts.toString() != BookMarkedProducts.LastComponentStatus;
    };
    BookMarkedProducts.setStatus = function () {
        BookMarkedProducts.LastComponentStatus = BookMarkedProducts.markedProducts.toString();
    };
    BookMarkedProducts.markedProducts = [];
    BookMarkedProducts.storageId = "";
    BookMarkedProducts.LastComponentStatus = "";
    return BookMarkedProducts;
}());
exports.BookMarkedProducts = BookMarkedProducts;
